import {Component, Input, OnInit} from '@angular/core';
import {CodigoProducto} from '../../../../model/class/CodigoProducto';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastsManager} from 'ng2-toastr';
import {CodigosProductoService} from '../../../services/codigos-prodicto/codigos-producto.service';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import {Producto} from '../../../../model/class/Producto';
import * as _ from 'lodash';
import {ProductoService} from '../../../services/producto/producto.service';

@Component({
  selector: 'app-crear-codigo',
  templateUrl: './crear-codigo.component.html',
  styleUrls: ['./crear-codigo.component.css']
})
export class CrearCodigoComponent implements OnInit {

  @Input() newCodigo: CodigoProducto;
  editando = false;
  loaders = {
    form: false,
    producto: false
  };
  txtBusquedaProd: string;
  textoRelChanged: Subject<string> = new Subject<string>();

  productoSelected: Producto;

  productosBuscados: Producto[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private toasts: ToastsManager,
    private codigosProductoService: CodigosProductoService,
    private productoService: ProductoService,
  ) {
    this.textoRelChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.txtBusquedaProd = model.toString();

        if (this.txtBusquedaProd === '') {
          this.productosBuscados = [];
        } else {
          this.buscarProducto(this.txtBusquedaProd);
        }
      });
  }

  ngOnInit() {

    if (this.newCodigo.id) {
      this.editando = true;
    }
  }

  onTextoChange(texto: string) {
    this.loaders.producto = true;
    this.textoRelChanged.next(texto);
  }

  limpiarTexto() {
    this.productosBuscados = [];
    this.txtBusquedaProd = '';
    this.productoSelected = undefined;
  }

  asignarProducto(producto: Producto) {
    this.productoSelected = producto;
    this.txtBusquedaProd = '';
  }

  buscarProducto(text: string) {
    let texto =  text.replace(new RegExp('span', 'ig'), '');
    texto = _.trim(texto);

    if (texto) {
      const objetoBucar: any[] = [{'name': texto}];
      const parametros = {search: JSON.stringify(objetoBucar)};

      this.productoService.getPublicados(parametros)
        .subscribe( data => {
          this.loaders.producto = false;
          for (const pord of data) {
            this.productosBuscados.push(new Producto(pord));
          }
        });
    } else {
      this.loaders.producto = false;
      this.productosBuscados = [];
    }
  }


  onSubmit() {
    // this.loaders.form = true;
    // if (this.editando) {
    //   this.documentoService.edit(this.newDocumento.id, this.newDocumento.getFormData())
    //     .subscribe(
    //       (data) => {
    //         this.loaders.form = false;
    //         this.toasts.success(`La Ficha a sido modificada exitosamente.`);
    //         this.activeModal.close(data.data);
    //       }, (error) => {
    //         this.loaders.form = false;
    //         this.toasts.error(`Ha ocurrido un error al modificar la Ficha.`);
    //
    //       }
    //     );
    // } else {
    //
    //   const objFicha = new Documento(this.newDocumento);
    //
    //   this.documentoService.create(objFicha.getFormData())
    //     .subscribe(
    //       (data) => {
    //         this.loaders.form = false;
    //         this.toasts.success(`La Ficha a sido creada exitosamente.`);
    //         this.activeModal.close(data.data);
    //       }, (error) => {
    //         this.loaders.form = false;
    //         this.toasts.error(`Ha ocurrido un error al crear la Ficha.`);
    //       }
    //     );
    // }

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-codigo/crear-codigo.component.ts